// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./SelectDropdown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.SelectInput {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
div.SelectInput > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.SelectInput > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.SelectInput > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.SelectInput.Borderless {
  border-color: inherit !important;
}
div.SelectInput.Borderless > div.select {
  background-color: inherit !important;
  border-color: transparent !important;
}
div.SelectInput.Borderless > div.select > div.selected-value > span.selected-value {
  padding-left: 0;
}
div.SelectInput.Borderless > div.select > div.selected-value > span.arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 10px;
}
div.SelectInput.invalid > div.select {
  border: 1px solid #D92D20;
}
div.SelectInput.invalid > div.select > div.selected-value {
  background: #FFF8F6;
  border: none;
}
div.SelectInput.invalid > div.select > div.selected-value:focus {
  border: none;
}
div.SelectInput > div.select {
  height: 100%;
  width: 100%;
  margin-left: 0;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  border-radius: 3px;
  position: relative;
}
div.SelectInput > div.select > div.selected-value {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border: 1px solid #D3D6DF;
  border-radius: 3px;
  height: 32px;
  background-color: #FFF;
  padding: 6px 0 6px 0;
}
div.SelectInput > div.select > div.selected-value:focus {
  border: 1px solid #01FF94;
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
div.SelectInput > div.select > div.selected-value > span.selected-value {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 18px;
  color: #002E33;
  max-width: calc(100% - 28px);
  white-space: nowrap;
  padding-left: 6px;
}
div.SelectInput > div.select > div.selected-value > span.selected-value > span.placeholder {
  color: #697588;
}
div.SelectInput > div.select > div.selected-value > span.arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 10px;
  width: 20px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
}
div.SelectInput > div.select > div.select-menu {
  background-color: #FFF;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  border: 1px solid #E8E9F0;
  overflow-y: hidden;
  margin-top: 2px;
  position: relative;
  z-index: 1000;
  width: 100%;
  min-width: 100px;
}
div.SelectInput > div.select > div.select-menu .optionsHolder {
  max-height: 220px;
  overflow-y: auto;
}
div.SelectInput > div.select > div.select-menu.up {
  position: absolute;
  bottom: 32px;
}
div.SelectInput > div.select > div.select-menu div.option {
  display: block;
  padding: 4px 6px 4px 8px;
  text-overflow: ellipsis;
  line-height: 1em;
  overflow: hidden;
  text-align: left;
}
div.SelectInput > div.select > div.select-menu div.option.active, div.SelectInput > div.select > div.select-menu div.option.menuOpen {
  background-color: #FFF;
  color: #002E33;
}
div.SelectInput > div.select > div.select-menu div.option.title {
  font-weight: bold;
  padding-bottom: 8px;
  padding-top: 15px;
}
div.SelectInput > div.select > div.select-menu div.option:hover {
  background: #F5F6F9;
}
div.SelectInput > div.select > div.select-menu div.search {
  border: 1px solid #D3D6DF;
  padding: 4px;
}
div.SelectInput > div.select > div.select-menu div.search > input {
  font-family: "Aeonik", sans-serif;
  font-size: 12px;
  width: calc(100% - 20px);
  border: none;
  outline: none;
}
div.SelectInput > div.select > div.select-menu div.search > span.clear {
  font-weight: bold;
  font-size: 1.1em;
  right: 20px;
}
div.SelectInput > div.select > div.select-menu div.search > span.clear:hover {
  cursor: pointer;
}
div.SelectInput > div.select > div.select-menu .action-btn {
  display: block;
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  clear: both;
  white-space: nowrap;
  border-top: 1px solid #E8E9F0;
  padding: 8px 8px;
  color: #002E33;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}
div.SelectInput > div.select > div.select-menu .action-btn:hover {
  color: #002E33;
}
div.SelectInput:focus .select div.selected-value, div.SelectInput.menuOpen .select div.selected-value {
  border: 1px solid #01FF94;
  outline: none;
}
div.SelectInput.LabelOnTop .select {
  width: 100% !important;
  margin-left: 0 !important;
  height: 32px;
}
div.SelectInput--disabled .select.Controlled {
  cursor: not-allowed;
}

div.Panel div.SelectInput.Input {
  height: inherit;
}
div.Panel div.SelectInput.Input > span.Label {
  display: block;
  position: relative;
  width: 100%;
}
div.Panel div.SelectInput.Input > span.Label + .Controlled {
  width: 100%;
  margin-left: 0;
}
div.Panel div.SelectInput.Input div.select span.arrow {
  top: auto;
  height: 30px;
}

td div.SelectInput.Input > div.select {
  background-color: #F5F6F9;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/SelectInput/SelectInput.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;ECiBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFKf;ACoBE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADIF;ACWE;EACE,UA9BS;EA+BT,gBA/BS;ADsBb;ACYE;EACE,kBAAA;ADVJ;AArBE;EACE,gCAAA;AAuBJ;AArBI;EACE,oCAAA;EACA,oCAAA;AAuBN;AApBQ;EACE,eAAA;AAsBV;AAnBQ;EACE,oEAAA;EACA,qBAAA;AAqBV;AAdI;EACE,yBAAA;AAgBN;AAfM;EACE,mBEmBD;EFlBC,YAAA;AAiBR;AAfM;EACE,YAAA;AAiBR;AAZE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cE3CW;EF4CX,kBAAA;EACA,kBAAA;AAcJ;AAZI;EACE,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;EAEA,YCtDQ;EDuDR,sBEhDE;EFiDF,oBAAA;AAaN;AAXM;EACE,yBAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;AAaR;AAVM;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,cErEO;EFsEP,4BAAA;EACA,mBAAA;EACA,iBAAA;AAYR;AAVQ;EACE,cExBD;AFoCT;AARM;EACE,2EAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AAUR;AALI;EACE,sBEvFE;EFwFF,wDAAA;UAAA,gDAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAON;AALM;EACE,iBAAA;EACA,gBAAA;AAOR;AAJM;EACE,kBAAA;EACA,YAAA;AAMR;AAHM;EACE,cAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAKR;AAHQ;EAEE,sBErHF;EFsHE,cE5HK;AFgIf;AADQ;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;AAGV;AADQ;EACE,mBE7ED;AFgFT;AACM;EACE,yBAAA;EACA,YAAA;AACR;AACQ;EACE,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;AACV;AAEQ;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAAV;AAEU;EACE,eAAA;AAAZ;AAKM;EACE,cAAA;EACA,WAAA;EACA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,cExKO;EFyKP,gBAAA;EACA,eAAA;EACA,eAAA;AAHR;AAKQ;EACE,cE9KK;AF2Kf;AAUE;EAEE,yBAAA;EACA,aAAA;AATJ;AAYE;EACE,sBAAA;EACA,yBAAA;EACA,YC/LU;ADqLd;AAeM;EACE,mBAAA;AAbR;;AAmBA;EACE,eAAA;AAhBF;AAkBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,SAAA;EACA,YAAA;AAlBJ;;AAuBE;EACE,yBExKK;AFoJT","sourcesContent":["@import \"../../../Global/InputBase\";\n@import \"../../../Global/Colors.scss\";\n\ndiv.SelectInput {\n  @include inputContainerRules;\n\n  &.Borderless {\n    border-color: inherit !important;\n\n    >div.select {\n      background-color: inherit !important;\n      border-color: transparent !important;\n\n      >div.selected-value {\n        >span.selected-value {\n          padding-left: 0;\n        }\n\n        >span.arrow {\n          background: url(SelectDropdown.svg) no-repeat center;\n          background-size: 10px;\n        }\n      }\n    }\n  }\n\n  &.invalid {\n    >div.select {\n      border: 1px solid $Red;\n      >div.selected-value {\n        background: $Red5;\n        border: none;\n      }\n      >div.selected-value:focus {\n        border: none;\n      }\n    }\n  }\n\n  >div.select {\n    height: 100%;\n    width: 100%;\n    margin-left: 0;\n    font-size: 12px;\n    line-height: 16px;\n    color: $DeepSeaGreen;\n    border-radius: 3px;\n    position: relative;\n\n    >div.selected-value {\n      box-sizing: border-box;\n      font-family: \"Aeonik\", sans-serif;\n      border: 1px solid $Gray50;\n      border-radius: 3px;\n\n      height: $inputHeight;\n      background-color: $White;\n      padding: 6px 0 6px 0;\n\n      &:focus {\n        border: 1px solid $ElectricGreen;\n        outline: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n      }\n\n      >span.selected-value {\n        display: inline-block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 18px;\n        color: $DeepSeaGreen;\n        max-width: calc(100% - 28px);\n        white-space: nowrap;\n        padding-left: 6px;\n\n        >span.placeholder {\n          color: $Gray90;\n        }\n      }\n\n      >span.arrow {\n        background: url(SelectDropdown.svg) no-repeat center center;\n        background-size: 10px;\n        width: 20px;\n        display: block;\n        position: absolute;\n        right: 0;\n        top: 0;\n        bottom: 0;\n      }\n\n    }\n\n    >div.select-menu {\n      background-color: $White;\n      box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n      border: 1px solid $Gray30;\n      overflow-y: hidden;\n      margin-top: 2px;\n      position: relative;\n      z-index: 1000;\n      width: 100%;\n      min-width: 100px;\n\n      .optionsHolder {\n        max-height: 220px;\n        overflow-y: auto;\n      }\n\n      &.up {\n        position: absolute;\n        bottom: 32px;\n      }\n\n      div.option {\n        display: block;\n        padding: 4px 6px 4px 8px;\n        text-overflow: ellipsis;\n        line-height: 1em;\n        overflow: hidden;\n        text-align: left;\n\n        &.active,\n        &.menuOpen {\n          background-color: $White;\n          color: $DeepSeaGreen;\n        }\n\n        &.title {\n          font-weight: bold;\n          padding-bottom: 8px;\n          padding-top: 15px;\n        }\n        &:hover {\n          background: $Gray20;\n        }\n      }\n\n      div.search {\n        border: 1px solid $Gray50;\n        padding: 4px;\n\n        >input {\n          font-family: \"Aeonik\", sans-serif;\n          font-size: 12px;\n          width: calc(100% - 20px);\n          border: none;\n          outline: none;\n        }\n\n        >span.clear {\n          font-weight: bold;\n          font-size: 1.1em;\n          right: 20px;\n\n          &:hover {\n            cursor: pointer;\n          }\n        }\n      }\n\n      .action-btn {\n        display: block;\n        width: 100%;\n        box-sizing: border-box;\n        clear: both;\n        white-space: nowrap;\n        border-top: 1px solid $Gray30;\n        padding: 8px 8px;\n        color: $DeepSeaGreen;\n        font-weight: 600;\n        font-size: 12px;\n        cursor: pointer;\n\n        &:hover {\n          color: $DeepSeaGreen;\n        }\n      }\n\n    }\n  }\n\n  &:focus .select div.selected-value,\n  &.menuOpen .select div.selected-value {\n    border: 1px solid $ElectricGreen;\n    outline: none;\n  }\n\n  &.LabelOnTop .select {\n    width: 100% !important;\n    margin-left: 0 !important;\n    height: $inputHeight;\n  }\n\n  &--disabled {\n    .select {\n      &.Controlled {\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\ndiv.Panel div.SelectInput.Input {\n  height: inherit;\n\n  >span.Label {\n    display: block;\n    position: relative;\n    width: 100%;\n  }\n\n  >span.Label+.Controlled {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  div.select span.arrow {\n    top: auto;\n    height: 30px;\n  }\n}\n\ntd div.SelectInput.Input {\n  >div.select {\n    background-color: $Gray20;\n  }\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
